/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { apikey } from '../models/apikey';
import type { responsesPartMeta } from '../models/responsesPartMeta';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ApikeysProcessesService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * get an authentication token from API key credentials
   * For enterprise-scoped API keys (see /processes/apikey/enterprise/generate), request a `companyUuid:<uuid>` scope value identifying which of the companies accessible to that enterprise identity to issue the access token for — e.g. `scope=companyUuid:5f010f1e-6fc1-447f-93a8-fad19668b3af`. This is a standard OAuth2 client_credentials request field, so any regular OAuth2 client can request it without Fountain-specific parameters.
   * @param formData
   * @returns any Successfully authenticated
   * @throws ApiError
   */
  public postApiServicesecurityProcessesApikeyOauthToken(
    formData?: {
      grant_type?: string;
      /**
       * Space-delimited scope values. Only relevant for enterprise-scoped API keys, which require a `companyUuid:<uuid>` value; ignored for standard company- and system-scoped keys.
       */
      scope?: string;
    },
  ): CancelablePromise<{
    access_token?: string;
    token_type?: string;
    expires_in?: number;
    scope?: string;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/apikey/oauth/token',
      formData: formData,
      mediaType: 'application/x-www-form-urlencoded',
      errors: {
        400: `invalid request`,
        401: `Authenticated failed`,
      },
    });
  }

  /**
   * get a Hire authentication token from API key credentials
   * @param requestBody
   * @returns any Successfully authenticated
   * @throws ApiError
   */
  public postApiServicesecurityProcessesApikeyHireApiToken(
    requestBody?: {
      hireAccountUuid: string;
      companyUuid?: string;
    },
  ): CancelablePromise<{
    access_token?: string;
    token_type?: string;
    expires_in?: number;
    scope?: string;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/apikey/hireApi/token',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `invalid request`,
        401: `Authenticated failed`,
      },
    });
  }

  /**
   * create a new enterprise-scoped API key for the calling enterprise identity
   * The returned key is not bound to a single company. Exchange it for a company-scoped access token via POST /processes/apikey/oauth/token, requesting a `companyUuid:<uuid>` scope value, for any company the enterprise identity has access to.
   * @param requestBody
   * @returns any Create a new enterprise-scoped API key
   * @throws ApiError
   */
  public postApiServicesecurityProcessesApikeyEnterpriseGenerate(
    requestBody?: {
      label: string;
    },
  ): CancelablePromise<{
    data?: apikey;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/apikey/enterprise/generate',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * list the calling enterprise identity's own enterprise-scoped API keys
   * Always scoped server-side to the calling enterprise identity — never returns another identity's or any company's API keys.
   * @returns any List of enterprise-scoped API keys
   * @throws ApiError
   */
  public getApiServicesecurityProcessesApikeyEnterpriseList(): CancelablePromise<{
    data?: Array<apikey>;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/servicesecurity/processes/apikey/enterprise/list',
    });
  }

  /**
   * delete one of the calling enterprise identity's own enterprise-scoped API keys
   * Ownership is enforced server-side (audience + userUuid + companyUuid) — returns 404 for a uuid that exists but belongs to another enterprise identity or any company, never deletes it.
   * @param apikeyUuid UUID of the enterprise-scoped API key to delete
   * @returns void
   * @throws ApiError
   */
  public deleteApiServicesecurityProcessesApikeyEnterprise(
    apikeyUuid: string,
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api/servicesecurity/processes/apikey/enterprise/{apikeyUuid}',
      path: {
        'apikeyUuid': apikeyUuid,
      },
      errors: {
        404: `Not found, or not owned by the calling enterprise identity`,
      },
    });
  }

  /**
   * create a new API key based on caller rights
   * @param requestBody
   * @returns any Create a new API key
   * @throws ApiError
   */
  public postApiServicesecurityProcessesApikeyGenerate(
    requestBody?: {
      label: string;
    },
  ): CancelablePromise<{
    data?: apikey;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/apikey/generate',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * create a new API key based on caller rights
   * @param userUuid User UUID of the user to generate the API key for
   * @param requestBody
   * @returns any Create a new API key
   * @throws ApiError
   */
  public postApiServicesecurityProcessesApikeyGenerateIntegration(
    userUuid: string,
    requestBody?: {
      label: string;
    },
  ): CancelablePromise<{
    data?: apikey;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/apikey/generate/integration/{userUuid}',
      path: {
        'userUuid': userUuid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

}
